import script from "./InventoryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryPage.vue?vue&type=script&setup=true&lang=js"

import "./InventoryPage.vue?vue&type=style&index=0&id=db0719fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db0719fc"]])

export default __exports__